

import galleryImg01 from '../../assets/images/gallery1.jpg'
import galleryImg02 from '../../assets/images/Gallery (8).jpg'
import galleryImg03 from '../../assets/images/Gallery (10).jpg'
import galleryImg04 from '../../assets/images/hi8.jpg'
import galleryImg05 from '../../assets/images/Gallery (12).jpg'
import galleryImg06 from '../../assets/images/Gallery (11).jpg'
import galleryImg07 from '../../assets/images/gallery2.jpg'
import galleryImg08 from '../../assets/images/Gallery (15).jpg'

const galleryImages = [
    galleryImg01,
  galleryImg07,
  galleryImg02,
  galleryImg06,
  galleryImg03,
  galleryImg04,
  galleryImg05,
  galleryImg08,
]

export default galleryImages;